// EmailService.js - A more robust email handling service

/**
 * Send an email notification for contact form submissions
 * This implementation uses FormSubmit.co which is a free email forwarding service
 * that doesn't require API keys for basic usage
 * 
 * @param {Object} contactData - The contact form data
 * @returns {Promise<Object>} - The result of the email sending operation
 */
export const sendContactNotification = async (contactData) => {
  try {
    // Format date for better readability
    const now = new Date();
    const formattedDate = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
    
    // FormSubmit.co endpoint - replace with your actual email
    const endpoint = 'https://formsubmit.co/ajax/bookkeeper@wisdomwaresllc.com';
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: contactData.name,
        email: contactData.email,
        phone: contactData.phone || 'Not provided',
        business: contactData.business || 'Not provided',
        message: contactData.message,
        _subject: `New Contact Form Submission from ${contactData.name}`,
        _template: 'table',
        _captcha: 'false', // Disable captcha for API submissions
        date: formattedDate
      })
    });
    
    const result = await response.json();
    return {
      success: true,
      data: result
    };
  } catch (error) {
    console.error('Failed to send email notification:', error);
    return {
      success: false,
      error: error.message || 'Unknown error occurred while sending email'
    };
  }
};

/**
 * Alternative implementation using EmailJS
 * Requires setting up an EmailJS account and adding credentials
 */
/*
import emailjs from 'emailjs-com';

export const sendContactNotificationEmailJS = async (contactData) => {
  try {
    const result = await emailjs.send(
      'YOUR_SERVICE_ID', // Create service in EmailJS dashboard
      'YOUR_TEMPLATE_ID', // Create email template in EmailJS
      {
        from_name: contactData.name,
        reply_to: contactData.email,
        phone: contactData.phone || 'Not provided',
        business: contactData.business || 'Not provided',
        message: contactData.message,
        to_email: 'bookkeeper@wisdomwaresllc.com'
      },
      'YOUR_USER_ID' // Get from EmailJS dashboard
    );
    
    return {
      success: true,
      data: result
    };
  } catch (error) {
    console.error('Failed to send EmailJS notification:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
*/